import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { HttpHeaders } from '@angular/common/http';
import { ResponseUtils } from '../response-utils';

export const kymw02Handlers = [
  http.post(
    PlessService.SERVICE.KYMW02getSpecifiedFile.url,
    async ({ request }) => {
      const req = await request;
      const b = await new Blob([
        'test,csv,one,,\ntest,csv,two,,',
      ]).arrayBuffer();
      const res = HttpResponse.arrayBuffer(b, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      return res;
      // return ResponseUtils.get500();
    }
  ),

  http.post(PlessService.SERVICE.KYMW02getCoopList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getCoopResponse);
    // return new HttpResponse('Internal Server Error', { status: 500 });
  }),

  http.post(PlessService.SERVICE.KYMW02getFeatureList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getFeatureListResponse);
    // return new HttpResponse('Internal Server Error', { status: 500 });
  }),

  http.post(PlessService.SERVICE.KYMW02getAllTagList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getAllTagListResponse);
    // return new HttpResponse('Internal Server Error', { status: 500 });
  }),

  http.post(PlessService.SERVICE.KYMW02getConvDivList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getConvDivListResponse);
    // return new HttpResponse('Internal Server Error', { status: 500 });
  }),

  // 画像ロック情報解除 /kymw02/releaseImageLock
  http.post(PlessService.SERVICE.releaseImageLock.url, ({ request }) => {
    const req = request.json();
    console.log(PlessService.SERVICE.releaseImageLock.url, req);
    return HttpResponse.json(releaseImageLockResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 企画商品フラグ媒体区分一覧取得 /KYMW02/getMediumListPlanGoodsFlag
  http.post(PlessService.SERVICE.KYMW02GetMediumListPlanGoodsFlag.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getMediumListPlanGoodsFlagResponse);
    // return new HttpResponse('Internal Server Error', { status: 500 });
  }),

  // コマ割実施フラグ媒体区分一覧取得 /KYMW02/getMediumListKomaFlag
  http.post(PlessService.SERVICE.KYMW02GetMediumListKomaFlag.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getMediumListKomaFlagResponse);
    // return new HttpResponse('Internal Server Error', { status: 500 });
  }),

  // // コードリスト取得 /kymw02/KYMW02getCodeList
  // http.post<unknown, { data: { parameter: { CodeDiv: string; }; }; }>(
  //   PlessService.SERVICE.KYMW02getCodeList.url,
  //   async ({ request }) => {
  //     const req = await request.json();
  //     const codeDiv = req.data.parameter.CodeDiv;
  //     console.log(PlessService.SERVICE.KYMW02getCodeList.url, ` [CodeDiv: ${codeDiv}]`, req);
  //     let response = getCodeListSampleResponse;
  //     if (codeDiv === 'ctp354') {
  //       response = getCodeListShortOfPointDivResponse;
  //     } else if (codeDiv === 'ctp334') {
  //       response = getCodeList334Response;
  //     } else if (codeDiv === 'ctp204') {
  //       response = getCodeList204Response;
  //     } else if (codeDiv === 'ctp254') {
  //       response = getCodeList254Response;
  //     } else if (codeDiv === 'ctp322') {
  //       response = getCodeList322Response;
  //     } else if (codeDiv === 'ct355') {
  //       response = getCodeList355Response;
  //     } else if (codeDiv === 'ctp203') {
  //       response = getCodeList203Response;
  //     } else if (codeDiv === 'ctp255') {
  //       response = getCodeList255Response;
  //     } else if (codeDiv === 'ctp267') {
  //       response = getCodeList267Response;
  //     } else if (codeDiv === 'ctp213') {
  //       response = getCodeList213Response;
  //     } else if (codeDiv === 'ctp206') {
  //       response = getCodeList206Response;
  //     } else if (codeDiv === 'ct028') {
  //       response = getCodeListct028Response;
  //     } else if (codeDiv === 'ctp212') {
  //       response = getCodeList212Response;
  //     } else if (codeDiv === 'ctp210') {
  //       response = getCodeList210Response;
  //     } else if (codeDiv === 'ctp211') {
  //       response = getCodeList211Response;
  //     } else if (codeDiv === 'ctp207') {
  //       response = getCodeList207Response;
  //     } else if (codeDiv === 'ctp209') {
  //       response = getCodeList209Response;
  //     } else if (codeDiv === 'ctp113') {
  //       response = getCodeList113Response;
  //     } else if (codeDiv === 'ctp114') {
  //       response = getCodeList114Response;
  //     } else if (codeDiv === 'ctp218') {
  //       response = getCodeList218Response;
  //     }
  //     return HttpResponse.json(response);
  //   }),

  http.post(PlessService.SERVICE.KYMW02getCatalogProgressList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getCatalogProgressListResponse);
    // return new HttpResponse('Internal Server Error', { status: 500 });
  }),

  // http.post(PlessService.SERVICE.KYMW02getOrderList.url, async ({ request }) => {
  //   const req = await request.json();
  //   return HttpResponse.json(getOrderListResponse);
  // }),

  // 列幅設定取得 /KYMW02/getUserColumnWidthSettings
  http.post<unknown, { data: { parameter: { UserId: string; GridId: string; }; }; }>(
    PlessService.SERVICE.getUserColumnWidthSettings.url,
    async ({ request }) => {
      const req = await request.json();
      const userId = req.data.parameter.UserId;
      const gridId = req.data.parameter.GridId;
      console.log(PlessService.SERVICE.getUserColumnWidthSettings.url, ` [UserId: ${userId}, GridId: ${gridId}]`, req);
      let response: any;
      if (userId === 'test01' && gridId === '1200') {
        response = getUserColumnWidthSettingsResponseKYMW1200Test01;
      } else if (userId === 'test20  ' && gridId === '1200') {
        response = getUserColumnWidthSettingsResponseKYMW1200Test20;
      } else if (userId === 'test20  ' && gridId === '1201' ) {
        response = getUserColumnWidthSettingsResponseKYMW1201Test20;
      } else {
        response = getUserColumnWidthSettingsResponse;
      }
      return HttpResponse.json(response);
    }
  ),

  // 列幅設定登録 /KYMW02/registUserColumnWidthSettings
  http.post(PlessService.SERVICE.registUserColumnWidthSettings.url, async ({ request }) => {
    return ResponseUtils.getSuccess();
    // return new HttpResponse('Internal Server Error', { status: 500 });
  }),
];

const getOrderListResponse = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "OrderCode": "2020010",
        "CatalogID": "20200304",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020020",
        "CatalogID": "20200401",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2020030",
        "CatalogID": "20200402",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2020040",
        "CatalogID": "20200403",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2020050",
        "CatalogID": "20200404",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020060",
        "CatalogID": "20200405",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2020070",
        "CatalogID": "20200501",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2020080",
        "CatalogID": "20200502",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2020090",
        "CatalogID": "20200503",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020100",
        "CatalogID": "20200504",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2020110",
        "CatalogID": "20200601",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2020120",
        "CatalogID": "20200602",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2020130",
        "CatalogID": "20200603",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020140",
        "CatalogID": "20200604",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2020150",
        "CatalogID": "20200701",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2020160",
        "CatalogID": "20200702",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2020170",
        "CatalogID": "20200703",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020180",
        "CatalogID": "20200704",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2020190",
        "CatalogID": "20200705",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2020200",
        "CatalogID": "20200801",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2020210",
        "CatalogID": "20200802",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020220",
        "CatalogID": "20200803",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2020230",
        "CatalogID": "20200804",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2020240",
        "CatalogID": "20200901",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2020250",
        "CatalogID": "20200902",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020260",
        "CatalogID": "20200903",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2020270",
        "CatalogID": "20200904",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2020280",
        "CatalogID": "20200905",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2020290",
        "CatalogID": "20201001",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020300",
        "CatalogID": "20201002",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2020310",
        "CatalogID": "20201003",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2020320",
        "CatalogID": "20201004",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2020330",
        "CatalogID": "20201101",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020340",
        "CatalogID": "20201102",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2020350",
        "CatalogID": "20201103",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2020360",
        "CatalogID": "20201104",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2020370",
        "CatalogID": "20201201",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020380",
        "CatalogID": "20201202",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2020390",
        "CatalogID": "20201203",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2020400",
        "CatalogID": "20201204",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2020410",
        "CatalogID": "20201205",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020420",
        "CatalogID": "20210101",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020430",
        "CatalogID": "20210102",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2020440",
        "CatalogID": "20210103",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2020450",
        "CatalogID": "20210104",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2020460",
        "CatalogID": "20210201",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020470",
        "CatalogID": "20210202",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2020480",
        "CatalogID": "20210203",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2020490",
        "CatalogID": "20210204",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2020500",
        "CatalogID": "20210301",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2020510",
        "CatalogID": "20210302",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2020520",
        "CatalogID": "20210303",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2021010",
        "CatalogID": "20210304",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021020",
        "CatalogID": "20210305",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2021030",
        "CatalogID": "20210401",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2021040",
        "CatalogID": "20210402",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2021050",
        "CatalogID": "20210403",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021060",
        "CatalogID": "20210404",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2021070",
        "CatalogID": "20210501",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2021080",
        "CatalogID": "20210502",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2021090",
        "CatalogID": "20210503",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021100",
        "CatalogID": "20210504",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2021110",
        "CatalogID": "20210601",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2021120",
        "CatalogID": "20210602",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2021130",
        "CatalogID": "20210603",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021140",
        "CatalogID": "20210604",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2021150",
        "CatalogID": "20210605",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2021160",
        "CatalogID": "20210701",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2021170",
        "CatalogID": "20210702",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021180",
        "CatalogID": "20210703",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2021190",
        "CatalogID": "20210704",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2021200",
        "CatalogID": "20210801",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2021210",
        "CatalogID": "20210802",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021220",
        "CatalogID": "20210803",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2021230",
        "CatalogID": "20210804",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2021240",
        "CatalogID": "20210901",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2021250",
        "CatalogID": "20210902",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021260",
        "CatalogID": "20210903",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2021270",
        "CatalogID": "20210904",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2021280",
        "CatalogID": "20210905",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2021290",
        "CatalogID": "20211001",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021300",
        "CatalogID": "20211002",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2021310",
        "CatalogID": "20211003",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2021320",
        "CatalogID": "20211004",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2021330",
        "CatalogID": "20211101",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021340",
        "CatalogID": "20211102",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2021350",
        "CatalogID": "20211103",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2021360",
        "CatalogID": "20211104",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2021370",
        "CatalogID": "20211201",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021380",
        "CatalogID": "20211202",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2021390",
        "CatalogID": "20211203",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2021400",
        "CatalogID": "20211204",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2021410",
        "CatalogID": "20211205",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021420",
        "CatalogID": "20220101",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021430",
        "CatalogID": "20220102",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2021440",
        "CatalogID": "20220103",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2021450",
        "CatalogID": "20220104",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2021460",
        "CatalogID": "20220201",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021470",
        "CatalogID": "20220202",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2021480",
        "CatalogID": "20220203",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2021490",
        "CatalogID": "20220204",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2021500",
        "CatalogID": "20220301",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2021510",
        "CatalogID": "20220302",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2021520",
        "CatalogID": "20220303",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2022010",
        "CatalogID": "20220304",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022020",
        "CatalogID": "20220305",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2022030",
        "CatalogID": "20220401",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2022040",
        "CatalogID": "20220402",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2022050",
        "CatalogID": "20220403",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022060",
        "CatalogID": "20220404",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2022070",
        "CatalogID": "20220501",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2022080",
        "CatalogID": "20220502",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2022090",
        "CatalogID": "20220503",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022100",
        "CatalogID": "20220504",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2022110",
        "CatalogID": "20220601",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2022120",
        "CatalogID": "20220602",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2022130",
        "CatalogID": "20220603",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022140",
        "CatalogID": "20220604",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2022150",
        "CatalogID": "20220605",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2022160",
        "CatalogID": "20220701",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2022170",
        "CatalogID": "20220702",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022180",
        "CatalogID": "20220703",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2022190",
        "CatalogID": "20220704",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2022200",
        "CatalogID": "20220801",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2022210",
        "CatalogID": "20220802",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022220",
        "CatalogID": "20220803",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2022230",
        "CatalogID": "20220804",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2022240",
        "CatalogID": "20220805",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2022250",
        "CatalogID": "20220901",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022260",
        "CatalogID": "20220902",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2022270",
        "CatalogID": "20220903",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2022280",
        "CatalogID": "20220904",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2022290",
        "CatalogID": "20221001",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022300",
        "CatalogID": "20221002",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2022310",
        "CatalogID": "20221003",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2022320",
        "CatalogID": "20221004",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2022330",
        "CatalogID": "20221101",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022340",
        "CatalogID": "20221102",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2022350",
        "CatalogID": "20221103",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2022360",
        "CatalogID": "20221104",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2022370",
        "CatalogID": "20221105",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022380",
        "CatalogID": "20221201",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2022390",
        "CatalogID": "20221202",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2022400",
        "CatalogID": "20221203",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2022410",
        "CatalogID": "20221204",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022420",
        "CatalogID": "20230101",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022430",
        "CatalogID": "20230102",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2022440",
        "CatalogID": "20230103",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2022450",
        "CatalogID": "20230104",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2022460",
        "CatalogID": "20230201",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022470",
        "CatalogID": "20230202",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2022480",
        "CatalogID": "20230203",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2022490",
        "CatalogID": "20230204",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2022500",
        "CatalogID": "20230301",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2022510",
        "CatalogID": "20230302",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2022520",
        "CatalogID": "20230303",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2023010",
        "CatalogID": "20230304",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023020",
        "CatalogID": "20230305",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2023030",
        "CatalogID": "20230401",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2023040",
        "CatalogID": "20230402",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2023050",
        "CatalogID": "20230403",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023060",
        "CatalogID": "20230404",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2023070",
        "CatalogID": "20230501",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2023080",
        "CatalogID": "20230502",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2023090",
        "CatalogID": "20230503",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023100",
        "CatalogID": "20230504",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2023110",
        "CatalogID": "20230505",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2023120",
        "CatalogID": "20230601",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2023130",
        "CatalogID": "20230602",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023140",
        "CatalogID": "20230603",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2023150",
        "CatalogID": "20230604",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2023160",
        "CatalogID": "20230701",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2023170",
        "CatalogID": "20230702",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023180",
        "CatalogID": "20230703",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2023190",
        "CatalogID": "20230704",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2023200",
        "CatalogID": "20230801",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2023210",
        "CatalogID": "20230802",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023220",
        "CatalogID": "20230803",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2023230",
        "CatalogID": "20230804",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2023240",
        "CatalogID": "20230805",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2023250",
        "CatalogID": "20230901",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023260",
        "CatalogID": "20230902",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2023270",
        "CatalogID": "20230903",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2023280",
        "CatalogID": "20230904",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2023290",
        "CatalogID": "20231001",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023300",
        "CatalogID": "20231002",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2023310",
        "CatalogID": "20231003",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2023320",
        "CatalogID": "20231004",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2023330",
        "CatalogID": "20231101",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023340",
        "CatalogID": "20231102",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2023350",
        "CatalogID": "20231103",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2023360",
        "CatalogID": "20231104",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2023370",
        "CatalogID": "20231105",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023380",
        "CatalogID": "20231201",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2023390",
        "CatalogID": "20231202",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2023400",
        "CatalogID": "20231203",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2023410",
        "CatalogID": "20231204",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023420",
        "CatalogID": "20231205",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023430",
        "CatalogID": "20240101",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2023440",
        "CatalogID": "20240102",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2023450",
        "CatalogID": "20240103",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2023460",
        "CatalogID": "20240104",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023470",
        "CatalogID": "20240201",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2023480",
        "CatalogID": "20240202",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2023490",
        "CatalogID": "20240203",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2023500",
        "CatalogID": "20240204",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2023510",
        "CatalogID": "20240301",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2023520",
        "CatalogID": "20240302",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2023530",
        "CatalogID": "20240303",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024010",
        "CatalogID": "20240304",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2024020",
        "CatalogID": "20240401",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2024030",
        "CatalogID": "20240402",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2024040",
        "CatalogID": "20240403",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024050",
        "CatalogID": "20240404",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2024060",
        "CatalogID": "20240501",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2024070",
        "CatalogID": "20240502",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2024080",
        "CatalogID": "20240503",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024090",
        "CatalogID": "20240504",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2024100",
        "CatalogID": "20240505",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2024110",
        "CatalogID": "20240601",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2024120",
        "CatalogID": "20240602",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024130",
        "CatalogID": "20240603",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2024140",
        "CatalogID": "20240604",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2024150",
        "CatalogID": "20240701",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2024160",
        "CatalogID": "20240702",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024170",
        "CatalogID": "20240703",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2024180",
        "CatalogID": "20240704",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2024190",
        "CatalogID": "20240705",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2024200",
        "CatalogID": "20240801",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024210",
        "CatalogID": "20240802",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2024220",
        "CatalogID": "20240803",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2024230",
        "CatalogID": "20240804",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2024240",
        "CatalogID": "20240901",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024250",
        "CatalogID": "20240902",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2024260",
        "CatalogID": "20240903",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2024270",
        "CatalogID": "20240904",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2024280",
        "CatalogID": "20241001",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024290",
        "CatalogID": "20241002",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2024300",
        "CatalogID": "20241003",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2024310",
        "CatalogID": "20241004",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2024320",
        "CatalogID": "20241005",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024330",
        "CatalogID": "20241101",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2024340",
        "CatalogID": "20241102",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2024350",
        "CatalogID": "20241103",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2024360",
        "CatalogID": "20241104",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024370",
        "CatalogID": "20241201",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2024380",
        "CatalogID": "20241202",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2024390",
        "CatalogID": "20241203",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2024400",
        "CatalogID": "20241204",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024410",
        "CatalogID": "20241205",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024420",
        "CatalogID": "20250101",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2024430",
        "CatalogID": "20250102",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2024440",
        "CatalogID": "20250103",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2024450",
        "CatalogID": "20250104",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024460",
        "CatalogID": "20250201",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2024470",
        "CatalogID": "20250202",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2024480",
        "CatalogID": "20250203",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2024490",
        "CatalogID": "20250204",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2024500",
        "CatalogID": "20250301",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2024510",
        "CatalogID": "20250302",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2024520",
        "CatalogID": "20250303",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2025010",
        "CatalogID": "20250304",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2025020",
        "CatalogID": "20250401",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2025030",
        "CatalogID": "20250402",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2025040",
        "CatalogID": "20250403",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2025050",
        "CatalogID": "20250404",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2025060",
        "CatalogID": "20250405",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2025070",
        "CatalogID": "20250501",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2025080",
        "CatalogID": "20250502",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2025090",
        "CatalogID": "20250503",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2025100",
        "CatalogID": "20250504",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2025110",
        "CatalogID": "20250601",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2025120",
        "CatalogID": "20250602",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2025130",
        "CatalogID": "20250603",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2025140",
        "CatalogID": "20250604",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2025150",
        "CatalogID": "20250701",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2025160",
        "CatalogID": "20250702",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2025170",
        "CatalogID": "20250703",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2025180",
        "CatalogID": "20250704",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2025190",
        "CatalogID": "20250705",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2025200",
        "CatalogID": "20250801",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2025210",
        "CatalogID": "20250802",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2025220",
        "CatalogID": "20250803",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2025230",
        "CatalogID": "20250901",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2025240",
        "CatalogID": "20250902",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2025250",
        "CatalogID": "20250903",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2025260",
        "CatalogID": "20250904",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2025270",
        "CatalogID": "20251001",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2025280",
        "CatalogID": "20251002",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2025290",
        "CatalogID": "20251003",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2025300",
        "CatalogID": "20251004",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2025310",
        "CatalogID": "20251005",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2025320",
        "CatalogID": "20251101",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2025330",
        "CatalogID": "20251102",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2025340",
        "CatalogID": "20251103",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2025350",
        "CatalogID": "20251104",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2025360",
        "CatalogID": "20251201",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2025370",
        "CatalogID": "20251202",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2025380",
        "CatalogID": "20251203",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2025390",
        "CatalogID": "20251204",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2025400",
        "CatalogID": "20251205",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2025410",
        "CatalogID": "20260101",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2025420",
        "CatalogID": "20260102",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2025430",
        "CatalogID": "20260103",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2025440",
        "CatalogID": "20260104",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2025450",
        "CatalogID": "20260201",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2025460",
        "CatalogID": "20260202",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2025470",
        "CatalogID": "20260203",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2025480",
        "CatalogID": "20260204",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2025490",
        "CatalogID": "20260301",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2025500",
        "CatalogID": "20260302",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2025510",
        "CatalogID": "20260303",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2026010",
        "CatalogID": "20260304",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2026020",
        "CatalogID": "20260401",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2026030",
        "CatalogID": "20260402",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2026040",
        "CatalogID": "20260403",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2026050",
        "CatalogID": "20260404",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2026060",
        "CatalogID": "20260405",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2026070",
        "CatalogID": "20260501",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2026080",
        "CatalogID": "20260502",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2026090",
        "CatalogID": "20260503",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2026100",
        "CatalogID": "20260504",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2026110",
        "CatalogID": "20260601",
        "RegistCycle": "Ａ週"
      },
      {
        "OrderCode": "2026120",
        "CatalogID": "20260602",
        "RegistCycle": "Ｂ週"
      },
      {
        "OrderCode": "2026130",
        "CatalogID": "20260603",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2026140",
        "CatalogID": "20260604",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2026150",
        "CatalogID": "20260701",
        "RegistCycle": "Ｃ週"
      },
      {
        "OrderCode": "2026160",
        "CatalogID": "20260702",
        "RegistCycle": "Ｄ週"
      },
      {
        "OrderCode": "2026161",
        "CatalogID": "20260701",
        "RegistCycle": "Ｃ週"
      }
    ]
  }
};

const getCoopResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        CoopCode: '142',
        CoopName: 'いばらきコープ',
        PlanCoopName: 'モック応答だよ',
        CoopShortName: 'い',
      },
    ],
  },
};

const getFeatureListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      FeatureList: [
        {
          FeatureCode: '11111',
          FeatureName: '特集名'
        },
        {
          FeatureCode: '22222',
          FeatureName: '特集２'
        },
        {
          FeatureCode: '33333',
          FeatureName: '特集３'
        },
        {
          FeatureCode: '44444',
          FeatureName: '特集４'
        },
        {
          FeatureCode: '55555',
          FeatureName: '特集５'
        },
      ]
    },
  },
};

const getAllTagListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      TagList: [
        {
          TagId: '11111111',
          TagName: 'タグ１'
        },
        {
          TagId: '22222222',
          TagName: 'タグ２'
        },
        {
          TagId: '33333333',
          TagName: 'タグ３'
        },
        {
          TagId: '44444444',
          TagName: 'タグ４'
        },
        {
          TagId: '55555555',
          TagName: 'タグ５'
        },
      ]
    },
  },
};

const getCodeListSampleResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        CodeDiv: 'mockCodeDiv',
        CodeDivName: '不明なコードリスト',
        CodeValue: '0',
        CodeName: 'モックコードA',
        Reserve1: '001',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      },
      {
        CodeDiv: 'mockCodeDiv',
        CodeDivName: '不明なコードリスト',
        CodeValue: '1',
        CodeName: 'モックコードB',
        Reserve1: '002',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      },
    ]
  }
};

const getConvDivListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        CategoryDiv: '1',
        ConvDiv: '01',
        ConvName: '部門×分類',
        ClassCodeCtrl: '1',
        LargeClassCodeCtrl: '1',
        MiddleClassCodeCtrl: '1',
        SmallClassCodeCtrl: '0',
        MarkCode1Ctrl: '0',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '0',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '0',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '0',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '0',
        Tag2Ctrl: '0',
      },
      {
        CategoryDiv: '1',
        ConvDiv: '28',
        ConvName: '部門×分類×タグ',
        ClassCodeCtrl: '1',
        LargeClassCodeCtrl: '1',
        MiddleClassCodeCtrl: '1',
        SmallClassCodeCtrl: '0',
        MarkCode1Ctrl: '0',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '0',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '0',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '0',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '1',
        Tag2Ctrl: '0',
      },
      {
        CategoryDiv: '2',
        ConvDiv: '29',
        ConvName: '媒体×特集（最新企画回）',
        ClassCodeCtrl: '0',
        LargeClassCodeCtrl: '0',
        MiddleClassCodeCtrl: '0',
        SmallClassCodeCtrl: '0',
        MarkCode1Ctrl: '0',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '1',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '0',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '0',
        FeatureCodeCtrl: '1',
        Tag1Ctrl: '0',
        Tag2Ctrl: '0',
      },
      {
        CategoryDiv: '2',
        ConvDiv: '30',
        ConvName: '価格パターン',
        ClassCodeCtrl: '0',
        LargeClassCodeCtrl: '0',
        MiddleClassCodeCtrl: '0',
        SmallClassCodeCtrl: '0',
        MarkCode1Ctrl: '0',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '0',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '0',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '1',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '0',
        Tag2Ctrl: '0',
      },
      {
        CategoryDiv: '2',
        ConvDiv: '31',
        ConvName: '価格パターン×媒体',
        ClassCodeCtrl: '0',
        LargeClassCodeCtrl: '0',
        MiddleClassCodeCtrl: '0',
        SmallClassCodeCtrl: '0',
        MarkCode1Ctrl: '0',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '1',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '0',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '1',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '0',
        Tag2Ctrl: '0',
      },
      {
        CategoryDiv: '2',
        ConvDiv: '32',
        ConvName: '価格パターン×媒体×ページ',
        ClassCodeCtrl: '0',
        LargeClassCodeCtrl: '0',
        MiddleClassCodeCtrl: '0',
        SmallClassCodeCtrl: '0',
        MarkCode1Ctrl: '0',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '1',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '1',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '1',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '0',
        Tag2Ctrl: '0',
      },
      {
        CategoryDiv: '2',
        ConvDiv: '33',
        ConvName: '価格パターン×部門×分類（中分類/小分類）',
        ClassCodeCtrl: '1',
        LargeClassCodeCtrl: '1',
        MiddleClassCodeCtrl: '1',
        SmallClassCodeCtrl: '1',
        MarkCode1Ctrl: '0',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '0',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '0',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '1',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '0',
        Tag2Ctrl: '0',
      },
      {
        CategoryDiv: '2',
        ConvDiv: '34',
        ConvName: '価格パターン×マーク',
        ClassCodeCtrl: '0',
        LargeClassCodeCtrl: '0',
        MiddleClassCodeCtrl: '0',
        SmallClassCodeCtrl: '0',
        MarkCode1Ctrl: '1',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '0',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '0',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '1',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '0',
        Tag2Ctrl: '0',
      },
      {
        CategoryDiv: '2',
        ConvDiv: '35',
        ConvName: '価格パターン×タグ',
        ClassCodeCtrl: '0',
        LargeClassCodeCtrl: '0',
        MiddleClassCodeCtrl: '0',
        SmallClassCodeCtrl: '0',
        MarkCode1Ctrl: '0',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '0',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '0',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '1',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '1',
        Tag2Ctrl: '0',
      },
      {
        CategoryDiv: '1',
        ConvDiv: '36',
        ConvName: 'タグ',
        ClassCodeCtrl: '0',
        LargeClassCodeCtrl: '0',
        MiddleClassCodeCtrl: '0',
        SmallClassCodeCtrl: '0',
        MarkCode1Ctrl: '0',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '0',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '0',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '0',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '1',
        Tag2Ctrl: '0',
      },
      {
        CategoryDiv: '1',
        ConvDiv: '37',
        ConvName: 'タグ１×タグ２',
        ClassCodeCtrl: '0',
        LargeClassCodeCtrl: '0',
        MiddleClassCodeCtrl: '0',
        SmallClassCodeCtrl: '0',
        MarkCode1Ctrl: '0',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '0',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '0',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '0',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '1',
        Tag2Ctrl: '1',
      },
      {
        CategoryDiv: '2',
        ConvDiv: '38',
        ConvName: 'タグ×媒体',
        ClassCodeCtrl: '0',
        LargeClassCodeCtrl: '0',
        MiddleClassCodeCtrl: '0',
        SmallClassCodeCtrl: '0',
        MarkCode1Ctrl: '0',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '1',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '0',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '0',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '1',
        Tag2Ctrl: '0',
      },
      {
        CategoryDiv: '2',
        ConvDiv: '39',
        ConvName: 'タグ×媒体×ページ',
        ClassCodeCtrl: '0',
        LargeClassCodeCtrl: '0',
        MiddleClassCodeCtrl: '0',
        SmallClassCodeCtrl: '0',
        MarkCode1Ctrl: '0',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '1',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '1',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '0',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '1',
        Tag2Ctrl: '0',
      },
      {
        CategoryDiv: '1',
        ConvDiv: '40',
        ConvName: 'タグ×部門×分類（中分類/小分類）',
        ClassCodeCtrl: '1',
        LargeClassCodeCtrl: '1',
        MiddleClassCodeCtrl: '1',
        SmallClassCodeCtrl: '1',
        MarkCode1Ctrl: '0',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '0',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '0',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '0',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '1',
        Tag2Ctrl: '0',
      },
      {
        CategoryDiv: '2',
        ConvDiv: '41',
        ConvName: 'タグ×マーク',
        ClassCodeCtrl: '0',
        LargeClassCodeCtrl: '0',
        MiddleClassCodeCtrl: '0',
        SmallClassCodeCtrl: '0',
        MarkCode1Ctrl: '1',
        MarkCode2Ctrl: '0',
        MarkCode3Ctrl: '0',
        MediumTypeCtrl: '0',
        PromotionDivCtrl: '0',
        PromotionInfoCtrl: '0',
        PageNumCtrl: '0',
        ExhibitionDivCtrl: '0',
        PricePatternCtrl: '0',
        FeatureCodeCtrl: '0',
        Tag1Ctrl: '1',
        Tag2Ctrl: '0',
      },
    ],
  },
};

const releaseImageLockResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      UnlockedInfo: {
        Image: []
      }
    }
  },
};

const getMediumListPlanGoodsFlagResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: [
      {
        MediumType: "001",
        MediumName: "はぴでり（企画商品フラグ媒体）",
        StopOrderCode: "9999999",
        ProgressWorkNum: "02",
        ProgressWorkName: "XXX",
        ReceiptEOrderCode: "9999999",
        ReceiptECatalogId: "99999999",
        MediumTypeClass: "0",
        DutiesFormDiv: "01"
      }, {
        MediumType: "041",
        MediumName: "XXX（企画商品フラグ媒体）",
        StopOrderCode: "9999999",
        ProgressWorkNum: "02",
        ProgressWorkName: "XXX",
        ReceiptEOrderCode: "9999999",
        ReceiptECatalogId: "99999999",
        MediumTypeClass: "0",
        DutiesFormDiv: "02"
      }, {
        MediumType: "018",
        MediumName: "校正紙のデフォルト",
        StopOrderCode: "9999999",
        ProgressWorkNum: "02",
        ProgressWorkName: "XXX",
        ReceiptEOrderCode: "9999999",
        ReceiptECatalogId: "99999999",
        MediumTypeClass: "0",
        DutiesFormDiv: "02"
      },
    ]
  }
}

const getMediumListKomaFlagResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: [
      {
        MediumType: "001",
        MediumName: "はぴでり（コマ割実施フラグ媒体）",
        StopOrderCode: "9999999",
        ProgressWorkNum: "02",
        ProgressWorkName: "XXX",
        ReceiptEOrderCode: "9999999",
        ReceiptECatalogId: "99999999",
        MediumTypeClass: "0",
        DutiesFormDiv: "01"
      }, {
        MediumType: "041",
        MediumName: "XXX（コマ割実施フラグ媒体）",
        StopOrderCode: "9999999",
        ProgressWorkNum: "02",
        ProgressWorkName: "XXX",
        ReceiptEOrderCode: "9999999",
        ReceiptECatalogId: "99999999",
        MediumTypeClass: "0",
        DutiesFormDiv: "02"
      },
    ]
  }
}

const getCodeListShortOfPointDivResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        CodeDiv: 'ctp354',
        CodeDivName: 'ポイント不足エラー区分',
        CodeValue: '0',
        CodeName: '通常商品に振り替えを行わない',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp354',
        CodeDivName: 'ポイント不足エラー区分',
        CodeValue: '1',
        CodeName: '通常商品に振り替えを行う',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
    ]
  }
};

const getCodeList334Response = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '10',
        CodeName: '毎週',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 1,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '21',
        CodeName: '隔週（Ａ，Ｃ）',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 2,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '22',
        CodeName: '隔週（Ｂ，Ｄ）',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 3,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '23',
        CodeName: '隔週（Ａ，Ｃ／Ｂ，Ｄ）',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 4,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '31',
        CodeName: '４週１回（Ａ）',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 5,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '32',
        CodeName: '４週１回（Ｂ）',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 6,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '33',
        CodeName: '４週１回（Ｃ）',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 7,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '34',
        CodeName: '４週１回（Ｄ）',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 8,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '41',
        CodeName: '１ヶ月毎',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 9,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '42',
        CodeName: '２ヶ月毎',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 10,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '43',
        CodeName: '３ヶ月毎',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 11,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '44',
        CodeName: '４ヶ月毎',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 12,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '45',
        CodeName: '５ヶ月毎',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 13,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
      {
        CodeDiv: 'ctp334',
        CodeDivName: '配達サイクル区分',
        CodeValue: '46',
        CodeName: '６ヶ月毎',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: 14,
        StartOrderCode: '2004010',
        EndOrderCode: '9999999'
      },
    ]
  }
}

const getCodeList204Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp204",
        "CodeValue": "001",
        "CodeName": "ハピデリ中面",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp204",
        "CodeValue": "002",
        "CodeName": "農産",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp204",
        "CodeValue": "003",
        "CodeName": "前回コピー",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 3,
        "StartOrderCode": "",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getCodeList254Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp254",
        "CodeValue": "0",
        "CodeName": "個別",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 0,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp254",
        "CodeValue": "1",
        "CodeName": "共通",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getCodeList322Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp322",
        "CodeValue": "0",
        "CodeName": "全体",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "       ",
        "EndOrderCode": "       "
      },
      {
        "CodeDiv": "ctp322",
        "CodeValue": "1",
        "CodeName": "eBASE取込後",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "       ",
        "EndOrderCode": "       "
      },
      {
        "CodeDiv": "ctp322",
        "CodeValue": "2",
        "CodeName": "仮登録",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 3,
        "StartOrderCode": "       ",
        "EndOrderCode": "       "
      },
      {
        "CodeDiv": "ctp322",
        "CodeValue": "3",
        "CodeName": "本登録",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 4,
        "StartOrderCode": "       ",
        "EndOrderCode": "       "
      }
    ]
  }
}

const getCodeList355Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ct355",
        "CodeValue": "0",
        "CodeName": "通常",
        "CodeDivName": "価格パターン",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": null,
        "StartOrderCode": "",
        "EndOrderCode": ""
      },
      {
        "CodeDiv": "ct355",
        "CodeValue": "1",
        "CodeName": "特価１",
        "CodeDivName": "価格パターン",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": null,
        "StartOrderCode": "",
        "EndOrderCode": ""
      },
      {
        "CodeDiv": "ct355",
        "CodeValue": "2",
        "CodeName": "特価２",
        "CodeDivName": "価格パターン",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": null,
        "StartOrderCode": "",
        "EndOrderCode": ""
      },
      {
        "CodeDiv": "ct355",
        "CodeValue": "3",
        "CodeName": "特価３",
        "CodeDivName": "価格パターン",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": null,
        "StartOrderCode": "",
        "EndOrderCode": ""
      }
    ]
  }
}

const getCodeList203Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp203",
        "CodeValue": "001",
        "CodeName": "サイクル・価格パターン設定",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp203",
        "CodeValue": "002",
        "CodeName": "供給価／計画数",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp203",
        "CodeValue": "003",
        "CodeName": "供給価／計画供給高（千円）",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 3,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp203",
        "CodeValue": "004",
        "CodeName": "供給価／実績数",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 4,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp203",
        "CodeValue": "005",
        "CodeName": "供給価／実績額（千円）",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 5,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getCodeList255Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp255",
        "CodeValue": "0",
        "CodeName": "提案前",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": null,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp255",
        "CodeValue": "1",
        "CodeName": "提案中",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": null,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp255",
        "CodeValue": "2",
        "CodeName": "バイヤー採用",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": null,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp255",
        "CodeValue": "3",
        "CodeName": "バイヤー不採用",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": null,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp255",
        "CodeValue": "4",
        "CodeName": "グループ長承認",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": null,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp255",
        "CodeValue": "5",
        "CodeName": "グループ長却下",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": null,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getCodeList267Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp267",
        "CodeValue": "0",
        "CodeName": "未登録",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp267",
        "CodeValue": "1",
        "CodeName": "登録済",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getCodeList213Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp213",
        "CodeValue": "01",
        "CodeName": "２名グループ利用値引",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp213",
        "CodeValue": "02",
        "CodeName": "３名以上グループ利用値引",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp213",
        "CodeValue": "03",
        "CodeName": "新規加入者クーポン",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 3,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp213",
        "CodeValue": "04",
        "CodeName": "アップロード",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 4,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getCodeList206Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp206",
        "CodeValue": "01",
        "CodeName": "増資",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp206",
        "CodeValue": "02",
        "CodeName": "募金",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp206",
        "CodeValue": "03",
        "CodeName": "ポイント利用",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 3,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp206",
        "CodeValue": "30",
        "CodeName": "忘れず注文一括休み",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 4,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp206",
        "CodeValue": "31",
        "CodeName": "忘れず注文グループ休み",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 5,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp206",
        "CodeValue": "40",
        "CodeName": "資料請求",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 6,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp206",
        "CodeValue": "41",
        "CodeName": "募集",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 7,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp206",
        "CodeValue": "50",
        "CodeName": "チラシセレクティブ",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 8,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp206",
        "CodeValue": "91",
        "CodeName": "供給",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 9,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp206",
        "CodeValue": "92",
        "CodeName": "手数料",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 10,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp206",
        "CodeValue": "93",
        "CodeName": "経費",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 11,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp206",
        "CodeValue": "94",
        "CodeName": "その他手数料",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 12,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getCatalogProgressListResponse = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "OrderCode": "2023160",
        "CatalogID": "20230701",
        "MediumType": "001",
        "ProgressWorkNum": "06",
        "ProgressWorkNumName": "誌面イメージＰＤＦ送信実行済み"
      },
      {
        "OrderCode": "2023170",
        "CatalogID": "20230702",
        "MediumType": "001",
        "ProgressWorkNum": "12",
        "ProgressWorkNumName": "商品企画データ送信（確定）実行済み"
      },
      {
        "OrderCode": "2023180",
        "CatalogID": "20230703",
        "MediumType": "001",
        "ProgressWorkNum": "12",
        "ProgressWorkNumName": "商品企画データ送信（確定）実行済み"
      },
      {
        "OrderCode": "2023190",
        "CatalogID": "20230704",
        "MediumType": "001",
        "ProgressWorkNum": "12",
        "ProgressWorkNumName": "商品企画データ送信（確定）実行済み"
      },
      {
        "OrderCode": "2023200",
        "CatalogID": "20230801",
        "MediumType": "001",
        "ProgressWorkNum": "12",
        "ProgressWorkNumName": "商品企画データ送信（確定）実行済み"
      },
      {
        "OrderCode": "2023210",
        "CatalogID": "20230802",
        "MediumType": "001",
        "ProgressWorkNum": "12",
        "ProgressWorkNumName": "商品企画データ送信（確定）実行済み"
      },
      {
        "OrderCode": "2023220",
        "CatalogID": "20230803",
        "MediumType": "001",
        "ProgressWorkNum": "12",
        "ProgressWorkNumName": "商品企画データ送信（確定）実行済み"
      },
      {
        "OrderCode": "2023230",
        "CatalogID": "20230804",
        "MediumType": "001",
        "ProgressWorkNum": "12",
        "ProgressWorkNumName": "商品企画データ送信（確定）実行済み"
      },
      {
        "OrderCode": "2023240",
        "CatalogID": "20230805",
        "MediumType": "001",
        "ProgressWorkNum": "12",
        "ProgressWorkNumName": "商品企画データ送信（確定）実行済み"
      },
      {
        "OrderCode": "2023250",
        "CatalogID": "20230901",
        "MediumType": "001",
        "ProgressWorkNum": "10",
        "ProgressWorkNumName": "商品企画データ送信（仮）実行済み"
      },
      {
        "OrderCode": "2023260",
        "CatalogID": "20230902",
        "MediumType": "001",
        "ProgressWorkNum": "09",
        "ProgressWorkNumName": "扱い確定連絡実行済み"
      },
      {
        "OrderCode": "2023270",
        "CatalogID": "20230903",
        "MediumType": "001",
        "ProgressWorkNum": "07",
        "ProgressWorkNumName": "企画確定"
      },
      {
        "OrderCode": "2023280",
        "CatalogID": "20230904",
        "MediumType": "001",
        "ProgressWorkNum": "05",
        "ProgressWorkNumName": "ＶＩＥＷ反映"
      },
      {
        "OrderCode": "2023290",
        "CatalogID": "20231001",
        "MediumType": "001",
        "ProgressWorkNum": "03",
        "ProgressWorkNumName": "初校入稿"
      },
      {
        "OrderCode": "2023300",
        "CatalogID": "20231002",
        "MediumType": "001",
        "ProgressWorkNum": "08",
        "ProgressWorkNumName": "初校入稿"
      },
      {
        "OrderCode": "2023310",
        "CatalogID": "20231003",
        "MediumType": "001",
        "ProgressWorkNum": "02",
        "ProgressWorkNumName": "扱い予定連絡実行済み"
      }
    ]
  }
}

const getCodeListct028Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ct028",
        "CodeValue": "01",
        "CodeName": "エラー",
        "CodeDivName": "ＰＤ区分",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": null,
        "StartOrderCode": "",
        "EndOrderCode": ""
      },
      {
        "CodeDiv": "ct028",
        "CodeValue": "14",
        "CodeName": "グロサリー（共Ｃ直納）Ａ",
        "CodeDivName": "ＰＤ区分",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": null,
        "StartOrderCode": "",
        "EndOrderCode": ""
      },
      {
        "CodeDiv": "ct028",
        "CodeValue": "99",
        "CodeName": "セット対象外",
        "CodeDivName": "ＰＤ区分",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": null,
        "StartOrderCode": "",
        "EndOrderCode": ""
      }
    ]
  }
}

const getCodeList212Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp212",
        "CodeValue": "01",
        "CodeName": "翌週",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp212",
        "CodeValue": "02",
        "CodeName": "翌々週",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getCodeList210Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp210",
        "CodeValue": "1",
        "CodeName": "外税",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp210",
        "CodeValue": "2",
        "CodeName": "内税",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp210",
        "CodeValue": "3",
        "CodeName": "非課税",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 3,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp210",
        "CodeValue": "9",
        "CodeName": "課税対象外",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 4,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getCodeList211Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp211",
        "CodeValue": "0",
        "CodeName": "0",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp211",
        "CodeValue": "8",
        "CodeName": "8",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp211",
        "CodeValue": "10",
        "CodeName": "10",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 3,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getCodeList207Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp207",
        "CodeValue": "4001",
        "CodeName": "資料請求（保険センター）",
        "CodeDivName": "",
        "Reserve1": "40",
        "Reserve2": "",
        "ReserveNum1": 40,
        "ReserveNum2": null,
        "SortNum": 76,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "4002",
        "CodeName": "資料請求（その他）",
        "CodeDivName": "",
        "Reserve1": "40",
        "Reserve2": "",
        "ReserveNum1": 40,
        "ReserveNum2": null,
        "SortNum": 77,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "4101",
        "CodeName": "募集（保険センター）",
        "CodeDivName": "",
        "Reserve1": "41",
        "Reserve2": "",
        "ReserveNum1": 41,
        "ReserveNum2": null,
        "SortNum": 78,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "4102",
        "CodeName": "募集（その他）",
        "CodeDivName": "",
        "Reserve1": "41",
        "Reserve2": "",
        "ReserveNum1": 41,
        "ReserveNum2": null,
        "SortNum": 79,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "9102",
        "CodeName": "部門",
        "CodeDivName": "",
        "Reserve1": "91",
        "Reserve2": "",
        "ReserveNum1": 91,
        "ReserveNum2": null,
        "SortNum": 82,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "9107",
        "CodeName": "リユース返金",
        "CodeDivName": "",
        "Reserve1": "91",
        "Reserve2": "",
        "ReserveNum1": 91,
        "ReserveNum2": null,
        "SortNum": 83,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "9203",
        "CodeName": "×基本手数料",
        "CodeDivName": "",
        "Reserve1": "92",
        "Reserve2": "",
        "ReserveNum1": 92,
        "ReserveNum2": null,
        "SortNum": 84,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "9204",
        "CodeName": "×配達手数料",
        "CodeDivName": "",
        "Reserve1": "92",
        "Reserve2": "",
        "ReserveNum1": 92,
        "ReserveNum2": null,
        "SortNum": 85,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "9205",
        "CodeName": "×別注手数料",
        "CodeDivName": "",
        "Reserve1": "92",
        "Reserve2": "",
        "ReserveNum1": 92,
        "ReserveNum2": null,
        "SortNum": 86,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "9271",
        "CodeName": "コンビニ振込対応手数料",
        "CodeDivName": "",
        "Reserve1": "92",
        "Reserve2": "",
        "ReserveNum1": 92,
        "ReserveNum2": null,
        "SortNum": 87,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "9272",
        "CodeName": "コンビニ振込対応手数料　税１０％",
        "CodeDivName": "",
        "Reserve1": "92",
        "Reserve2": "",
        "ReserveNum1": 92,
        "ReserveNum2": null,
        "SortNum": 88,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "9290",
        "CodeName": "基本手数料",
        "CodeDivName": "",
        "Reserve1": "92",
        "Reserve2": "",
        "ReserveNum1": 92,
        "ReserveNum2": null,
        "SortNum": 89,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "9291",
        "CodeName": "配達手数料",
        "CodeDivName": "",
        "Reserve1": "92",
        "Reserve2": "",
        "ReserveNum1": 92,
        "ReserveNum2": null,
        "SortNum": 90,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "9292",
        "CodeName": "別注手数料",
        "CodeDivName": "",
        "Reserve1": "92",
        "Reserve2": "",
        "ReserveNum1": 92,
        "ReserveNum2": null,
        "SortNum": 91,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp207",
        "CodeValue": "9293",
        "CodeName": "早朝配達手数料",
        "CodeDivName": "",
        "Reserve1": "92",
        "Reserve2": "",
        "ReserveNum1": 92,
        "ReserveNum2": null,
        "SortNum": 255,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getCodeList209Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp209",
        "CodeValue": "01",
        "CodeName": "農産",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp209",
        "CodeValue": "02",
        "CodeName": "水産",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getCodeList113Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp113",
        "CodeValue": "XX1",
        "CodeName": "いつでも注文",
        "CodeDivName": "",
        "Reserve1": "00",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp113",
        "CodeValue": "XX6",
        "CodeName": "いつでも注文・お酒",
        "CodeDivName": "",
        "Reserve1": "15",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp113",
        "CodeValue": "XX2",
        "CodeName": "いつでも注文・法人",
        "CodeDivName": "",
        "Reserve1": "10",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp113",
        "CodeValue": "XX4",
        "CodeName": "いきいきくらす",
        "CodeDivName": "",
        "Reserve1": "13",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp113",
        "CodeValue": "XX3",
        "CodeName": "ターゲット",
        "CodeDivName": "",
        "Reserve1": "11",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp113",
        "CodeValue": "XX5",
        "CodeName": "いつでも注文・特別企画",
        "CodeDivName": "",
        "Reserve1": "14",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
    ]
  }
}

const getCodeList114Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp114",
        "CodeValue": "1",
        "CodeName": "ピース企画",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp114",
        "CodeValue": "2",
        "CodeName": "デリ運営企画",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getCodeList218Response = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "CodeDiv": "ctp218",
        "CodeValue": "A",
        "CodeName": "Ａグループ",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp218",
        "CodeValue": "B",
        "CodeName": "Ｂグループ",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp218",
        "CodeValue": "C",
        "CodeName": "Ｃグループ",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp218",
        "CodeValue": "D",
        "CodeName": "Ｄグループ",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 2,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      },
      {
        "CodeDiv": "ctp218",
        "CodeValue": "9",
        "CodeName": "設定なし",
        "CodeDivName": "",
        "Reserve1": "",
        "Reserve2": "",
        "ReserveNum1": null,
        "ReserveNum2": null,
        "SortNum": 1,
        "StartOrderCode": "2004010",
        "EndOrderCode": "9999999"
      }
    ]
  }
}

const getUserColumnWidthSettingsResponse = {
  "status": "ok",
  "message": "処理終了",
  "result": {
    "obj": {
    }
  }
}

const getUserColumnWidthSettingsResponseKYMW1200Test01 = {
  "status": "ok",
  "message": "処理終了",
  "result": {
    "obj": {
      "ColumnInfo": {
        "2023160": {width: 100, displayFlg: "1"},
        "2023170": {width: 100, displayFlg: "1"},
        "2023180": {width: 100, displayFlg: "1"},
        "2023190": {width: 100, displayFlg: "1"},
        "2023200": {width: 100, displayFlg: "1"},
        "中分類名": {width: 50, displayFlg: "1"},
        "小分類名": {width: 50, displayFlg: "0"},
        "分類タグ情報": {width: 200, displayFlg: "0"},
        "他タグ情報": {width: 200, displayFlg: "0"},
        "Ｐコード": {width: 150, displayFlg: "0"},
        "関連Ｐコード": {width: 40, displayFlg: "1"},
        "商品名": {width: 10, displayFlg: "1"},
        "規格名": {width: 10, displayFlg: "1"},
        "支払先取引先": {width: 100, displayFlg: "1"},
        "発注先取引先": {width: 200, displayFlg: "1"},
        "取扱生協": {width: 200, displayFlg: "1"},
        "媒体区分": {width: 400, displayFlg: "1"},
        "部門": {width: 50, displayFlg: "1"},
        "アイテムコード": {width: 10, displayFlg: "1"},
        "ＪＡＮコード": {width: 10, displayFlg: "1"},
        "大分類名": {width: 10, displayFlg: "1"},
        "取扱期間（終了）": {width: 10, displayFlg: "1"},
        "商品メモ": {width: 20, displayFlg: "1"},
        "商品別個数集計": {width: 10, displayFlg: "1"},
        "商品別金額集計（千円）": {width: 10, displayFlg: "1"}
      }
    }
  }
}

const getUserColumnWidthSettingsResponseKYMW1200Test20 = {
  "status": "ok",
  "message": "処理終了",
  "result": {
    "obj": {
      "ColumnInfo": {
        "2023160": {width: 50, displayFlg: "1"},
        "2023170": {width: 50, displayFlg: "1"},
        "2023180": {width: 50, displayFlg: "1"},
        "2023190": {width: 50, displayFlg: "1"},
        "2023200": {width: 50, displayFlg: "1"},
        "中分類名": {width: 50, displayFlg: "0"},
        "小分類名": {width: 50, displayFlg: "0"},
        "分類タグ情報": {width: 50, displayFlg: "1"},
        "他タグ情報": {width: 342, displayFlg: "1"},
        "Ｐコード": {width: 242, displayFlg: "1"},
        "関連Ｐコード": {width: 174, displayFlg: "1"},
        "商品名": {width: 50, displayFlg: "1"},
        "規格名": {width: 50, displayFlg: "1"},
        "本体供給価格（通常）": {width: 155, displayFlg: "1"},
        "単仕入価格（通常）": {width: 0, displayFlg: "1"},
        "GPR（通常）": {width: 78, displayFlg: "0"},
        "本体供給価格（特１）": {width: 47, displayFlg: "1"},
        "単仕入価格（特１）": {width: 158, displayFlg: "1"},
        "GPR（特１）": {width: 0, displayFlg: "1"},
        "本体供給価格（特２）": {width: 0, displayFlg: "1"},
        "単仕入価格（特２）": {width: 98, displayFlg: "0"},
        "GPR（特２）": {width: 201, displayFlg: "1"},
        "支払先取引先": {width: 50, displayFlg: "1"},
        "発注先取引先": {width: 50, displayFlg: "1"},
        "取扱生協": {width: 50, displayFlg: "1"},
        "媒体区分": {width: 50, displayFlg: "1"},
        "部門": {width: 50, displayFlg: "1"},
        "アイテムコード": {width: 50, displayFlg: "1"},
        "ＪＡＮコード": {width: 50, displayFlg: "1"},
        "大分類名": {width: 50, displayFlg: "1"},
        "取扱期間（終了）": {width: 50, displayFlg: "1"},
        "商品メモ": {width: 50, displayFlg: "1"},
        "商品別個数集計": {width: 390, displayFlg: "1"},
        "商品別金額集計（千円）": {width: 262, displayFlg: "1"}
      }
    }
  }
}

const getUserColumnWidthSettingsResponseKYMW1201Test20 = {
  "status": "ok",
  "message": "処理終了",
  "result": {
    "obj": {
      "ColumnInfo": {
        "受注コード": {width: 50, displayFlg: "1"},
        "配達企画回": {width: 50, displayFlg: "1"},
        "部門": {width: 50, displayFlg: "1"},
        "中分類名": {width: 50, displayFlg: "0"},
        "小分類名": {width: 50, displayFlg: "0"},
        "商品名": {width: 50, displayFlg: "1"},
        "規格名": {width: 50, displayFlg: "1"},
        "Pコード": {width: 242, displayFlg: "1"},
        "アイテムコード": {width: 50, displayFlg: "1"},
        "JANコード": {width: 50, displayFlg: "1"},
        "大分類名": {width: 50, displayFlg: "1"},
        "支払先取引先": {width: 50, displayFlg: "1"},
        "発注先取引先": {width: 50, displayFlg: "1"},
        "取扱期間（終了）": {width: 50, displayFlg: "1"},
        "特集コード": {width: 50, displayFlg: "1"},
        "ノンブル": {width: 50, displayFlg: "1"},
        "EDLP": {width: 50, displayFlg: "1"},
        "忘れず注文取": {width: 50, displayFlg: "1"},
        "商品メモ": {width: 50, displayFlg: "1"},
        "い": {width: 50, displayFlg: "1"},
        "と": {width: 50, displayFlg: "1"},
        "ぐ": {width: 50, displayFlg: "1"},
        "ち": {width: 50, displayFlg: "1"},
        "さ": {width: 50, displayFlg: "1"},
        "とう": {width: 50, displayFlg: "1"},
        "な": {width: 50, displayFlg: "1"},
        "に": {width: 50, displayFlg: "1"},
        "価格パターン": {width: 50, displayFlg: "1"},
        "価格プロモーション": {width: 50, displayFlg: "1"},
        "登場区分": {width: 50, displayFlg: "1"},
        "お買い得期間": {width: 50, displayFlg: "1"},
        "コマプロモーション": {width: 50, displayFlg: "1"},
        "プロモーションマーク": {width: 50, displayFlg: "1"},
        "注文コード割当": {width: 50, displayFlg: "1"},
        "W・媒体内": {width: 50, displayFlg: "1"},
        "クロス商品": {width: 342, displayFlg: "1"},
        "クロス設定確定": {width: 174, displayFlg: "1"},
        "W・クロス": {width: 50, displayFlg: "1"},
        "今回供給価": {width: 50, displayFlg: "1"},
        "今回仕入価": {width: 390, displayFlg: "1"},
        "計画数(予測)": {width: 262, displayFlg: "1"},
        "計画数(修正)": {width: 262, displayFlg: "1"},
        "PI値": {width: 262, displayFlg: "1"},
        "供給高": {width: 262, displayFlg: "1"},
        "GP高": {width: 262, displayFlg: "1"},
        "GPR": {width: 262, displayFlg: "1"},
      }
    }
  }
}
